export default __webpack_public_path__ + "static/media/DSC09952.cc76838f.JPG";